import { createSelector } from 'reselect';

import { selectFeatureFlags } from '../../../store/selectors';

import { GlobalState } from '../../../types.global';
import { CustomPicture, Picture, UiState } from './types';

export const selectUi = ({ ui }: GlobalState): UiState => ui;

export const selectModalName = ({ ui }: GlobalState): string => ui.modalName;

export const selectDefaultBackground = createSelector(
  selectFeatureFlags,
  (featureFlags): { activeView: string; mode: string } => {
    if (!featureFlags.OCEAN_PICTURES_OFF) {
      return { activeView: 'default', mode: 'gallery' };
    }
    return { activeView: 'dark', mode: 'dark' };
  }
);

export const selectBackgroundPicture = createSelector(
  ({ ui }) => ui.mode,
  ({ ui }) => ui.customPicture,
  ({ ui }) => ui.gallery,

  (mode, customPicture, gallery): Picture | null => {
    if (mode === 'custom') {
      return { url: customPicture.raw || customPicture.pictureUrl };
    }

    if (['gallery', 'focus', 'speed'].includes(mode)) {
      return gallery.image.picture;
    }

    return null;
  }
);

export const selectCustomPicture = ({ ui }: GlobalState): CustomPicture =>
  ui.customPicture;

export const selectCustomPictureUrl = (state: GlobalState): string =>
  selectCustomPicture(state).pictureUrl;

export const selectActiveBgCategory = ({ ui }: GlobalState): string =>
  ui.gallery.category;

export const selectActiveView = createSelector(
  ({ ui }) => ui.activeView,
  (activeView): { view: string; category: string } => {
    const [view, category] = activeView.split(':');
    return { view, category };
  }
);

export const selectBackgroundCategory = ({ ui }: GlobalState): string =>
  ui.gallery.category;

export const selectCurrentImageFeedback = createSelector(
  ({ ui }) => ui.gallery,
  (gallery) => {
    const { picture } = gallery.image;
    return {
      liked: !!gallery.liked.find((url) => url === picture.url),
      disliked: !!gallery.disliked.find((url) => url === picture.url),
    };
  }
);

export const selectVideoBackground = createSelector(
  ({ ui }) => ui.videoBackground,
  (videoBackground) => {
    return { videoBackground };
  }
);
